import { render } from "./NecesidadesEspeciales.vue?vue&type=template&id=a6250872"
import script from "./NecesidadesEspeciales.vue?vue&type=script&lang=js"
export * from "./NecesidadesEspeciales.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__